export const DISPLAY_TIME_FORMAT = 'hh:mm a';
export const DISPLAY_TIME_PLACEHOLDER = 'HH:MM AM/PM';
export const ERROR_INVALID_TIME_RANGE = 'Invalid time range.';
export const ERROR_INVALID_START_TIME =
  'Start time must be greater than the current time.';
export const ERROR_INVALID_DATE_RANGE = 'Invalid date range';
export const ERROR_TIME_SLOTS_OVERLAPPED =
  'Slots in a day cannot be overlapped.';
